import type { CategoryBucketAttributes } from "@/entities/form-metadata";
import { useTrackSearchFormInteraction } from "@/shared/lib/ube";

type BucketKey = keyof CategoryBucketAttributes["buckets"];

const SELECT_ACTION = {
    records: "select_historical_records",
    stories: "select_stories_publications",
    trees: "select_family_trees",
    photos: "select_photos_maps",
} as const satisfies Record<BucketKey, string>;

const UNSELECT_ACTION = {
    records: "unselect_historical_records",
    stories: "unselect_stories_publications",
    trees: "unselect_family_trees",
    photos: "unselect_photos_maps",
} as const satisfies Record<BucketKey, string>;

export const useCategoryBucketTracking = () => {
    const track = useTrackSearchFormInteraction();

    return (bucketKey: BucketKey, next: boolean) => {
        track({
            action: next ? SELECT_ACTION[bucketKey] : UNSELECT_ACTION[bucketKey],
            objectName: "category_bucket",
        });
    };
};
